import {
    DataRecord,
    getMetricLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, GaugeSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsGaugeChartProps,
    EchartsGaugeFormData,
    GaugeChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
  
export default function transformProps(
    chartProps: EchartsGaugeChartProps,
): GaugeChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      metrics,
      showLabels,
      tooltipFormat,
      valueFormat,
      rangeMax,
      showLegend
    }: EchartsGaugeFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    const metricLabels = metrics ? metrics.map(getMetricLabel) : [];
  
    const { setDataMask = () => {} } = hooks;

    const offsetCenter: { title: {[key: number]: string[]}, detail: {[key: number]: string[]} }[] = [
      {
        title: {
          0: ['0%', '80%'],
        },
        detail: {
          0: ['0%', '95%'],
        }
      },
      {
        title: {
          0: ['-40%', '80%'],
          1: ['40%', '80%'],
        },
        detail: {
          0: ['-40%', '95%'],
          1: ['40%', '95%'],
        }
      },
      {
        title: {
          0: ['-80%', '80%'],
          1: ['0%', '80%'],
          2: ['80%', '80%']
        },
        detail: {
          0: ['-80%', '95%'],
          1: ['0%', '95%'],
          2: ['80%', '95%']
        }
      },
    ]

    const seriesData = data.length === 1 ? metricLabels.map((metricLabel, idx) => {
      return {
        name: metricLabel,
        value: data[0][metricLabel],
        title: {
          show: showLabels,
          offsetCenter: offsetCenter[metricLabels.length - 1].title[idx]
        },
        detail: {
          show: showLabels,
          valueAnimation: true,
          offsetCenter: offsetCenter[metricLabels.length - 1].detail[idx]
        }
      };
    }) : [];
    
    const series: GaugeSeriesOption[] = [
      {
        type: 'gauge',
        max: parseInt(rangeMax, 10),
        anchor: {
          show: true,
          showAbove: true,
          size: 18,
          itemStyle: {
            color: '#FAC858'
          }
        },
        pointer: {
          icon: 'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
          width: 8,
          length: '80%',
          offsetCenter: [0, '8%']
        },
        progress: {
          show: true,
          overlap: true,
          roundCap: true
        },
        axisLine: {
          roundCap: true
        },
        title: {
          fontSize: 14
        },
        detail: {
          width: 40,
          height: 14,
          fontSize: 14,
          color: '#fff',
          backgroundColor: 'inherit',
          borderRadius: 3,
          formatter: valueFormat
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {
        formatter: tooltipFormat
      },
      legend: {
        show: showLegend
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
    };
}
  